mutation EntityTagSupplierCreate($input: EntityTagSupplierCreateInput!) {
  entityTagSupplierCreate(input: $input) {
    entityTags {
      id
      tagId
      entityId
      appId
    }
  }
}
